import { createTheme, Theme as MuiTheme, ThemeProvider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import clientConfig from '../../config/client-config';
import { AppState } from '../store';
import {
  assignChristmassVariables,
  assignDarkVariables,
  assignHighContrastVariables,
  assignLightVariables
} from '../store/reducers/theme/theme-variables';

export type ThemeProviderWrapperProps = {
  children: React.ReactNode;
};

const ThemeProviderWrapper = ({ children }: ThemeProviderWrapperProps) => {
  const selectedTheme = useSelector((state: AppState) => state.themeReducer.currentTheme);
  const [theme, setTheme] = useState<MuiTheme | undefined>();

  const getLightTheme = () => {
    assignLightVariables();
    const themeConfig = clientConfig.themes.light;
    return createTheme({
      palette: themeConfig.colors,
      ...clientConfig.general
    });
  };

  const getDarkTheme = () => {
    assignDarkVariables();
    const themeConfig = clientConfig.themes.dark;
    return createTheme({
      palette: themeConfig.colors,
      ...clientConfig.general
    });
  };

  const getHighContrastTheme = () => {
    assignHighContrastVariables();
    const themeConfig = clientConfig.themes.highContrast;
    return createTheme({
      palette: themeConfig.colors,
      ...clientConfig.general
    });
  };

  const getChristmassTheme = () => {
    assignChristmassVariables();
    const themeConfig = clientConfig.themes.christmas;
    return createTheme({
      palette: themeConfig.colors,
      ...clientConfig.general
    });
  };

  useEffect(() => {
    let defaultTheme = getLightTheme();

    if (selectedTheme === 'DARK') defaultTheme = getDarkTheme();
    if (selectedTheme === 'HIGH_CONTRAST') defaultTheme = getHighContrastTheme();
    if (selectedTheme === 'CHRISTMASS') defaultTheme = getChristmassTheme();

    setTheme(defaultTheme);
  }, [selectedTheme]);

  if (!theme) return <></>;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
